import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/hooks";
// import { store } from "../../store/store";
import EventServices from "../../services/EventServices";
import { IEvent } from "../../store/eventApiSlice";
import MemberServices from "../../services/MemberServices";
import {
  // Outlet,
  useNavigate,
} from "react-router-dom";
// import EventList from "../Events/EventList";
import OrderEventList from "./orderEventList";
import OrderEventDetail from "./orderEventdetail";
import {
  Button,
  Label,
  // SecondaryButton,
  PageLink,
  // Label,
} from "../StyledComp/StyledComp";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import OrderServices from "../../services/OrderServices";
import {
  ICost,
  ILocation,
  initalOrderItem,
  IOrderItem,
  // orderApiSlice,
  resetOrderParameters,
  storeAddOrderItem,
  storeAssignOrderItem,
  storeUpdateOrder,
  storeUpdateOrderItem,
  storeUpdateOrderItem1,
  // IOrder,
} from "../../store/orderApiSlice";
// import MDEditSectionMultipleOptionItems from "../MemberDetail/MDEditSectionMultipleOptionItems";
import { ThemeProvider } from "styled-components";
import ReactModal from "react-modal";
import { TextField, createTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useForm, Controller } from "react-hook-form";
import * as routeConfig from "../../config/routes";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
import MDEditSectionMultipleOptionItems from "../MemberDetail/MDEditSectionMultipleOptionItems";
import { updateMember_Sections } from "../../store/memberApiSlice";
import InvoiceServices from "../../services/InvoiceServices";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { color } from "framer-motion";
import { isNullishCoalesce } from "typescript";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { it } from "node:test";

// interface IConfiguration {
//   [key: string]: any;
// }

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  Status: boolean;
}

interface IMemberCode {
  Id: number;
  MemberCode: string;
  Description: string;
  Fee: number;
  FromYear: number;
  AdvanceMemberCode: string;
  Status: number;
  SectionStatus: number;
}

// const memberCodeInit: IMemberCode = {
//   Id: 1,
//   MemberCode: "w",
//   Description: "w",
//   Fee: 1,
//   FromYear: 1,
//   AdvanceMemberCode: "w",
//   Status: 1,
// };

// interface ISection {
//   Fee: number;
//   Id: number;
//   SectionDescription: string;
//   SectionName: string;
//   isSelected: boolean;
// }

// interface ISelectedSections {
//   Id: number | null;
//   SectionName: string | null;
//   MemberId: number | null;
// }
interface IFunctionOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface ISeminarOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

interface IActiveOrder {
  FunctioOrders: IFunctionOrders[];
  SeminarOrders: ISeminarOrders[];
  memberShipOrderDetails: IMemberShipOrders[];
}

interface ISelectedSections {
  Id: number | null;
  SectionName: string | null;
  MemberId: number | null;
}

interface IReturnFromOrderInfo {
  receiptURL: string | null;
  newOrderId: number | null;
}

const initalActiveOrder: IActiveOrder = {
  FunctioOrders: [],
  SeminarOrders: [],
  memberShipOrderDetails: [],
};

interface IProps {
  isPaymentFlow: boolean;
  currentYearActiveOrderId: number[];
  proratedDue: number | null;
  isAddSectionFlow: boolean;
  //section: ISection;
  // isSection: boolean;
  // onChangeFunction: (
  // event: React.ChangeEvent<HTMLInputElement>,
  // section: ISection
  // ) => void;
}

type createOrderFormValues = {
  MemberCodeId: number;
};

const CreateAdvanceOrder: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentMonth = new Date().getMonth() + 1;
  const [proratedDue, setproratedDue] = useState<number | null>(null);
  // const [SortField, setSortField] = useState("UniqueEventId");
  const currentMember = useAppSelector((state) => state.currentMember);
  const orderInfo = useAppSelector((store) => store.orderapislice);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [isAddSectionFlow, setIsAddSectionFlow] = useState<boolean>(
        props.isAddSectionFlow
      );
  // const [OrderDetail, setOrderDetail] = useState<IOrder>(orderInfo);

  const [activeSeminarEvents, setactiveSeminarEvents] = useState<IEvent[]>([]);
  const [activeVideoEvents, setactiveVideoEvents] = useState<IEvent[]>([]);
  const [activeFunctionEvents, setactiveFunctionEvents] = useState<IEvent[]>(
    []
  );

  const formPaymentInfo = useForm<IPaymentInfo>();
  const {
    register: registerPI,
    control: controlPI,
    handleSubmit: handleSubmitPI,
    formState: formStatePI,
    setValue: setValuePI,
    clearErrors: clearErrorsPI,
  } = formPaymentInfo;

  // const memberForm = useForm();
  // const {
  //   setValue: setValueMF,
  //   getValues: getValuesMF,
  //   trigger: triggerMF,
  // } = memberForm;
  // //const memberCodeId = getValues("MemberCodeId");

  let storeTotalAmount = useAppSelector(
    (store) => store.orderapislice.TotalAmount
  );

  let storeAmountPaid = useAppSelector(
    (store) => store.orderapislice.AmountPaid
  );

  let storeCouponAmount = useAppSelector(
    (store) => store.orderapislice.CouponAmount
  );


  let SelectedSections = currentMember.MemberSections;

  const [selectedEventType, setSelectedEventType] = useState<number>(2);
  const [currentEventScreen, setCurrentEventScreen] =
    useState<string>("OrderEventList");
  // const [currentscreen, setcurrentscreen] = useState<string>("OrderEventList");
  const [Sections, setSections] = useState<ISection[]>();
  const [totalAmount, setTotalAmount] = useState<number>(storeTotalAmount);
  const [couponAmount, setCouponAmount] = useState<number>(storeCouponAmount);
  const [AmountPaid, setAmountPaid] = useState<number>(storeAmountPaid);
  const [totalSectionAmount, setTotalSectionAmount] = useState<number>(0);
  const [totalNextYearSectionAmount, setTotalNextYearSectionAmount] = useState<number>(0);
  const [membershipAmount, setMembershipAmount] = useState<number>(0);
  const [dueAmount, setDueAmount] = useState<number>(0);
  const sectionArray = SelectedSections?.map((section: any) => {
    return section.Id;
  });

  const [datePaid, setDatePaid] = useState<Dayjs | null>(null);

  // const [datePaid, setDatePaid] = useState<Dayjs | null>(
  //   orderInfo?.DatePaid ? dayjs(orderInfo?.DatePaid) : null
  // );

  const [invoiceURL, setinvoiceURL] = useState<string>("");
  const [receiptURL, setReceiptURL] = useState<string>("");
  const [lateFee, setLateFee] = useState<number>(0);
  const [createOrderModalOpen, setCreateOrderModalOpen] = useState(false);
  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<
    (number | null)[] | undefined
  >(sectionArray);

  const [orderItem, setOrderItem] = useState<IOrderItem>({
    ...initalOrderItem,
  });

  const [memberCodes, setMemberCodes] = useState<IMemberCode[]>();
  const [memberCode, setMemberCode] = useState<string>();
  const [memberCodeId, setMemberCodeId] = useState<number>();
  const [memberCodeDesc, setMemberCodeDesc] = useState<string>();

  const [lastMemberCode, setLastMemberCode] = useState<string>();
  const [lastMemberCodeId, setLastMemberCodeId] = useState<number>();
  const [lastMemberCodeDesc, setLastMemberCodeDesc] = useState<string>();

  const [participantType, setParticipantType] = useState<string>("");
  const [TransactionType, setTransactionType] = useState<string>("");
  const [eventCostList, setEventCostList] = useState<ICost[]>([]);
  const [eventLocation, setEventLocation] = useState<ILocation>();
  const [isSubmitOrderInfoLoading, setIsSubmitOrderInfoLoading] =
    useState<boolean>(false);
  const [isSubmitPaymentInfoLoading, setIsSubmitPaymentInfoLoading] =
    useState<boolean>(false);
  const [PIModalOpen, setPIModalOpen] = useState(false);
  const [lastYearSections, setLastYearSections] = useState<number[]>([]);
  const formSubmitOrderInfo = useForm<IPaymentInfo>();
  const {
    register: registerSubmitOrder,
    control: controlSubmitOrder,
    handleSubmit: handleSubmitOrder,
    formState: formStateSubmitOrder,
    setValue: setValueSubmitOrder,
    clearErrors: clearErrorsSubmitOrder,
  } = formSubmitOrderInfo;

  const {
    errors: SubmitOrderInfoErrors,
    touchedFields: SubmitOrderInfoTouchedFields,
    dirtyFields: SubmitOrderInfoDirtyFields,
  } = formStateSubmitOrder;

  const createOrderForm = useForm<createOrderFormValues>();
  const {
    register: createOrderRegister,
    control: createOrderControl,
    handleSubmit: createOrderHandleSubmit,
    formState: createOrderFormState,
    setValue: createOrderSetValue,
    trigger: createOrderTrigger,
  } = createOrderForm;
  const {
    errors: createOrderErrors,
    touchedFields: createOrderTouchedFields,
    dirtyFields: createOrderDirtyFields,
  } = createOrderFormState;

  // const eventTypeCheckboxoptions = [
  //   { id: 1, label: "Sections" },
  //   { id: 2, label: "Membership" },
  // ];

  // const eventTypeCheckboxoptions = [
  //   { id: 1, label: "Seminar" },
  //   { id: 2, label: "Video" },
  //   { id: 3, label: "Function" },
  //   { id: 4, label: "Sections" },
  //   { id: 5, label: "Membership" },
  // ];

  // const paymentInfoInitialState: IPaymentInfo = {
  //   PaymentMethod: "",
  //   DatePaid: dayjs(new Date("01/1/24")),
  //   CheckNumber: "",
  //   LateFee: 0,
  //   AuthCode: "",
  //   PIComments: "",
  //   NoInvoiceFlag: false,
  // };

  // const [PaymentInfo, setPaymentInfo] = useState<IPaymentInfo>(
  //   paymentInfoInitialState
  // );

  const [MembersActiveOrders, setMembersActiveOrders] =
    useState<IActiveOrder>(initalActiveOrder);
  const [MembersActiveOrdersNumArray, setMembersActiveOrdersNumArray] =
    useState<number[]>([]);
  const [isMembersActiveOrdersLoaded, setIsMembersActiveOrders] =
    useState<boolean>(false);
  // During first render, I don't want to set isActiveOrdersDataLoaded,
  // isActiveEventsDataLoaded and isSectionsDataLoaded as true
  let publishedAddress = currentMember.PublishedAddress;
  let pubAddress: string[] = [];
  publishedAddress?.Address1 && pubAddress.push(publishedAddress?.Address1);
  publishedAddress?.Address2 && pubAddress.push(publishedAddress?.Address2);
  publishedAddress?.City && pubAddress.push(publishedAddress?.City);
  publishedAddress?.County && pubAddress.push(publishedAddress?.County);
  publishedAddress?.State && pubAddress.push(publishedAddress?.State);
  publishedAddress?.Zipcode && pubAddress.push(publishedAddress?.Zipcode);
  // const [
  //   isFirstRenderOfActiveOrdersDataLoaded,
  //   setIsFirstRenderOfActiveOrdersDataLoaded,
  // ] = useState<boolean>(true);
  const [
    isFirstRenderOfActiveEventsDataLoaded,
    setIsFirstRenderOfActiveEventsDataLoaded,
  ] = useState<boolean>(true);
  // const [
  //   isFirstRenderOfSectionsDataLoaded,
  //   setIsFirstRenderOfSectionsDataLoaded,
  // ] = useState<boolean>(true);

  // const [isActiveOrdersDataLoaded, setIsActiveOrdersDataLoaded] =
  //   useState<boolean>(false);
  const [isActiveEventsDataLoaded, setIsActiveEventsDataLoaded] =
    useState<boolean>(false);
  // const [isSectionsDataLoaded, setIsSectionsDataLoaded] =
  //   useState<boolean>(false);

  console.log("Sections-create order:", Sections);

  useEffect(() => {
    console.log("create order useEFFECT CALLED", currentMember);

    console.log("useffect[]-SelectedSections:", SelectedSections);
    console.log("useffect[]-sectionArray:", sectionArray);
    console.log("useffect[]-selectedItems:", selectedItems);

    console.log(
      "CO: currentYearActiveOrderId:",
      props.currentYearActiveOrderId
    );

    if (currentMember.BarId === "") {
      // console.log("currentMember EMPTY");
      navigate("/member", { replace: false });
    }

    if(props.proratedDue!= null && props.proratedDue > 0) {
      console.log("props.proratedDue:", props.proratedDue);
      setproratedDue(props.proratedDue);
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        ProratedDues: props.proratedDue,
      }));
      // If member has already paid current year, automatically include next year
      if (currentMember.IsCurrentYearDuePaid) {
        setOrderItem((prevOrderItem) => ({
          ...prevOrderItem,
          IncludeNextYear: true,
        }));
      }
    }

    if(currentMember.MemberCodeFee === 0) {
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        IncludeNextYear: true,
      }));
    }

    // dispatch(resetOrderParameters());

    // const getActiveEventList = async () => {
    //   const response = await EventServices.getEventList();
    //   console.log("active events response...", response.data.data);
    //   if (response.data.data != null) {
    //     // console.log("Success:", response.data.data);
    //     setactiveSeminarEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Seminar" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     setactiveFunctionEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Function" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     setactiveVideoEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Video" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     // setEventList(response.data.data.Events);
    //     // dispatch(updateEventList(response.data.data.Events));
    //   } else {
    //   }
    // };
    // getActiveEventList();

    const getOrderListsForMemberID = async () => {
      try {
        const response = await OrderServices.getFutureOrderByMemberId(
          currentMember.Id!
        );
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          /* if (
            response.data.data.memberShipOrderDetails &&
            response.data.data.memberShipOrderDetails[0]!
              .CurrentYearSections !== null
          ) {
            response.data.data.memberShipOrderDetails[0]!
              .CurrentYearSectionsNotPaid = response.data.data.memberShipOrderDetails[0]!
              .CurrentYearSections;

          } */
          console.log("Success-getOrderByMemberId:", response.data.data);
          
          setMembersActiveOrders(response.data.data);
          // setIsActiveOrdersDataLoaded(true);
          if (
            response.data.data.memberShipOrderDetails &&
            response.data.data.memberShipOrderDetails[0]!
              .CurrentYearSectionsNotPaid !== null
          ) {
            setSelectedItems(
              response.data.data.memberShipOrderDetails[0].CurrentYearSectionsNotPaid.split(
                ","
              ).map(Number)
            );

            console.log("selectedItems:", selectedItems);
            let total = 0
            for (const item of response.data.data.memberShipOrderDetailsUpdated!) {
              if(item.IsSelected === 1) {
                total += item.Fee;
              }
            }
            setTotalSectionAmount(currentMember.MemberCodeFee === 0 ? 0 : total);
            setTotalNextYearSectionAmount(currentMember.MemberCodeFee === 0 ? 0 :total)
          }
        } else {
          // setIsActiveOrdersDataLoaded(true);
          // setIsActiveOrdersDataLoaded(false); // check this
        }
      } catch (error) {
        // setIsActiveOrdersDataLoaded(true);
        // setIsActiveOrdersDataLoaded(false); //check this
        // Handle errors from the API call
      }
    };

    getOrderListsForMemberID();

    const getConfigurationLists = async () => {
      try {
        const response = await MemberServices.getConfigurationList();
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("Success11:", response.data.data);
          // setConfigurationList(response.data.data);
          // setSectionIsSelectedFlag(response.data.data.MemberSection);
          // dispatch(
          //   storeUpdateOrder({
          //     key: "Sections",
          //     value: response.data.data.MemberSection,
          //   })
          // );

          // setTimeout(() => {
          //   // Code to be executed after 3 seconds
          //   setSections(response.data.data.MemberSection);
          //   // setMemberCodes(response.data.data.MemberCode);
          //   console.log("Execution resumed after 9 seconds");
          // }, 9000);
          // setting this state variable just to reload incase response from API is delayed
          let configSections = response.data.data.MemberSection;
          if(currentMember.SectionStatus === 0){
            for(let i = 0; i < configSections.length; i++){
              configSections[i].Fee = 0;
            }
          }
          setSections(configSections);
          setMemberCodes(response.data.data.MemberCode);
        }
      } catch (error) {
        // Handle errors from the API call
      }
    };

    getConfigurationLists();

    const updateOrderDetail = () => {
      if (currentMember.Id != null) {
        console.log("setCurrentMember:", currentMember);
        dispatch(
          storeUpdateOrder({
            key: "MemberId",
            value: currentMember?.Id,
          })
        );
        console.log("currentMember.Id:", currentMember?.Id);
        dispatch(
          storeUpdateOrder({
            key: "OrderType",
            value: "Membership",
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "IsAddSection",
            value: isAddSectionFlow,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: null,
          })
        );
        const currentDate = new Date(); // Get current date
        const currentYear = currentDate.getFullYear(); // Get current year
        const currentMonth = currentDate.getMonth(); // Get current month (0 for Jan, 11 for Dec)
        /* if (currentMonth < 4) {
          dispatch(
            storeUpdateOrder({
              key: "enrollmentStartDate",
              value: dayjs(new Date(currentYear - 1, 6, 1)).format(
                "YYYY-MM-DD"
              ),
            })
          );
          console.log(
            "enrollmentStartDate:",
            dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD")
          );
          dispatch(
            storeUpdateOrder({
              key: "enrollmentEndDate",
              value: dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD"),
            })
          );
        } else { */
          dispatch(
            storeUpdateOrder({
              key: "enrollmentStartDate",
              value: dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD"),
            })
          );
          dispatch(
            storeUpdateOrder({
              //storeUpdateOrderItem({
              key: "enrollmentEndDate",
              value: dayjs(new Date(currentYear + 1, 5, 30)).format(
                "YYYY-MM-DD"
              ),
            })
          );
        //}
      }
    };
    updateOrderDetail();

    /* if (currentMember.IsCurrentYearDuePaid) {
      currentMember &&
        currentMember.MemberCodeId &&
        setMemberCodeId(currentMember.MemberCodeId);

      currentMember &&
        currentMember.MemberCode &&
        setMemberCode(currentMember.MemberCode);

      currentMember &&
        currentMember.Description &&
        setMemberCodeDesc(currentMember.Description);
    } else { */
      if (currentMember && currentMember.isEligibleForAdvance) {
        currentMember.AdvanceMemberCodeId &&
          setMemberCodeId(currentMember.AdvanceMemberCodeId);
      } else {
        currentMember.MemberCodeId &&
          setMemberCodeId(currentMember.MemberCodeId);
        console.log(
          "Setting up MemberCodeId in useEffect[]",
          currentMember.MemberCodeId
        );
      }
      currentMember &&
        currentMember.MemberCodeId &&
        setLastMemberCodeId(currentMember.MemberCodeId);

      currentMember &&
        currentMember.MemberCode &&
        setLastMemberCode(currentMember.MemberCode);

      currentMember &&
        currentMember.Description &&
        setLastMemberCodeDesc(currentMember.Description);
    //}

    const lastYearSectionsString = currentMember?.lastYearSections || "";
    const lastYearSections: number[] = lastYearSectionsString
      ? lastYearSectionsString.split(",").map(Number)
      : [];
    setLastYearSections(lastYearSections);
  }, []);

  useEffect(() => {
    console.log("userEffect-lastYearSections SelectedItems", selectedItems);
    setSelectedItems(lastYearSections);
  }, [lastYearSections]);

  useEffect(() => {
    console.log("useEffect-totalSectionAmount", totalSectionAmount);
  }, [totalSectionAmount]);

  useEffect(() => {
    if (memberCodeId !== null) {
      memberCodeId && updateMemberCode(memberCodeId);
      memberCodeId && console.log("MemberCodeId is set:", memberCodeId);
      // setValueMF("MemberCodeId", memberCodeId, {
      //   shouldValidate: true, // Validate when the value changes
      //   shouldDirty: true, // Mark it as dirty when the value changes
      // });
    }
  }, [memberCodeId, memberCodes]);

  useEffect(() => {
    console.log("setMembersActiveOrdersNumArray:", MembersActiveOrdersNumArray);
  }, [MembersActiveOrdersNumArray]);

  useEffect(() => {
    // validating
    //console.log("orderInfo111:", orderItem);
    console.log("orderItem value changed:", orderItem);
    // dispatch(
    //   storeUpdateOrderItem1({
    //     key: "Orders",
    //     value: orderItem,
    //   })
    // );
    dispatch(
      storeAssignOrderItem({
        key: "Orders",
        value: orderItem,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "DueAmount",
        value: dueAmount,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "TotalAmount",
        value: totalAmount,
      })
    );
    setTotalAmount(totalAmount);
  }, [orderItem]);

  useEffect(() => {
    setIsMembersActiveOrders(true);
    console.log("MemberActiveORder1:", MembersActiveOrders);
  }, [MembersActiveOrders]);

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      // Only run if selectedItems has meaningful values
      console.log("selectedItems in useEffect:", selectedItems);
      orderItem &&
        console.log(
          "orderItem.CurrentYearSections:",
          orderItem.CurrentYearSections
        );
      // dispatch(updateMember_Sections(selectedItems as number[]));

      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        CurrentYearSections: selectedItems,
      }));
      dispatch(
        storeUpdateOrder({
          key: "HasSectionOrderItem",
          value: true,
        })
      );
    }
  }, [selectedItems]);

  useEffect(() => {
    console.log("useEffect-SelectedSections called", SelectedSections);
    console.log("useEffect-SelectedSections orderItem:", orderItem);
    console.log("useEffect-SelectedSections called", selectedItems);

    if (SelectedSections && Sections) {
      const initialSelectedItems: number[] =
        selectedItems && selectedItems.length > 0
          ? selectedItems.filter((item): item is number => item !== null) // Filter out null values : [];
          : [];

      let initialTotalSectionAmount = 0;
      let initialTotalAmount = 0;

      console.log("initialTotalSectionAmount1:", initialTotalSectionAmount);
      // props.isPaymentFlow &&
      //   Sections &&
      //   Sections.forEach((section: ISection) => {
      //     if (
      //       selectedItems &&
      //       selectedItems?.some((item) => item === section.Id)
      //     ) {
      //       initialTotalSectionAmount = initialTotalSectionAmount + section.Fee;
      //     }
      //   });
      console.log("initialTotalSectionAmount2:", initialTotalSectionAmount);
      dispatch(
        storeUpdateOrder({
          key: "DueAmount",
          value: initialTotalAmount,
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "TotalAmount",
          value: initialTotalAmount,
        })
      );
      console.log(
        "useEffect-SelectedSections SelectedSections:",
        SelectedSections
      );
      SelectedSections.forEach((selectedSection) => {
        // Find the corresponding section from the master list
        const matchedSection = Sections.find(
          (section) =>
            section.Id === selectedSection.Id &&
            !MembersActiveOrdersNumArray.includes(section.Id) // Exclude sections in MembersActiveOrdersNumArray
        );

        if (matchedSection) {
          selectedSection.Id && initialSelectedItems.push(selectedSection.Id);
          if (props.isPaymentFlow) {
            initialTotalSectionAmount += matchedSection.Fee;
          }
        }
      });

      setSelectedItems(initialSelectedItems);
      console.log("initialTotalSectionAmount3:", initialTotalSectionAmount);
      console.log("TotalSectionAmount1:", totalSectionAmount);
      setTotalSectionAmount(currentMember.MemberCodeFee === 0 ? 0 : initialTotalSectionAmount);
      //setTotalAmount(initialTotalAmount);
      //if (props.isPaymentFlow) {
      //setDueAmount(initialTotalAmount);
      //}

      // console.log("SelectedItems1:", initialSelectedItems);
      // console.log("initialTotalAmount1:", initialTotalAmount);
    }
  }, [SelectedSections, Sections]);

  useEffect(() => {
    const totalAmount_local1 = totalSectionAmount + membershipAmount + lateFee;
    setTotalAmount(totalAmount_local1);
    setDueAmount(totalAmount_local1);
    dispatch(
      storeUpdateOrder({
        key: "TotalAmount",
        value: totalAmount_local1,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "DueAmount",
        value: totalAmount_local1,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "LateFee",
        value: lateFee,
      })
    );
    console.log("totalAmount_local1:", totalAmount_local1);
    console.log("lateFee:", lateFee);
  }, [lateFee]);

  useEffect(() => {
    console.log("memberCodes initalized:", memberCodes);
  }, [memberCodes]);
  // useEffect(() => {
  //   console.log("SeminarEvents Count:", activeSeminarEvents.length);
  //   console.log("FunctionEvents Count:", activeFunctionEvents.length);
  //   console.log("VideoEvents Count:", activeVideoEvents.length);
  //   if (isFirstRenderOfActiveEventsDataLoaded) {
  //     setIsFirstRenderOfActiveEventsDataLoaded(false);
  //   } else {
  //     setIsActiveEventsDataLoaded(true);
  //   }
  // }, [activeSeminarEvents, activeFunctionEvents, activeVideoEvents]);

  // useEffect(() => {
  //   console.log(
  //     "SeminarOrders Count:",
  //     MembersActiveOrders.FunctioOrders.length
  //   );
  //   console.log(
  //     "FunctionOrders Count:",
  //     MembersActiveOrders.SeminarOrders.length
  //   );
  //   console.log(
  //     "memberShipOrderDetails Count:",
  //     MembersActiveOrders.memberShipOrderDetails.length
  //   );
  //   if (isFirstRenderOfActiveOrdersDataLoaded) {
  //     setIsFirstRenderOfActiveOrdersDataLoaded(false);
  //   } else {
  //     setIsActiveOrdersDataLoaded(true);
  //   }
  // }, [MembersActiveOrders]);

  // useEffect(() => {
  //   console.log("Sections count:", Sections?.length);
  //   //I dont want setIsSectionsDataLoaded to be called when first time
  //   // this useEffect is triggered. only want ot to be called only when useEffect
  //   // is triggered due to change in Sections state variable
  //   if (isFirstRenderOfSectionsDataLoaded) {
  //     setIsFirstRenderOfSectionsDataLoaded(false);
  //   } else {
  //     setIsSectionsDataLoaded(true);
  //   }
  // }, [Sections]);

  if (typeof Sections != "undefined") {
    Sections.map((section: ISection) => {
      const isChecked1 = (selecedFlag: ISelectedSections) => {
        return selecedFlag.Id === section.Id;
      };

      if (SelectedSections?.some(isChecked1)) {
        section.isSelected = true;
      } else {
        section.isSelected = false;
      }
    });
  }

  const onEventScreenChange = (eventScreen: string) => {
    setCurrentEventScreen(eventScreen);
    console.log("eventScreen:", eventScreen);
  };

  const handleEventTypeRadioChange = (id: number) => {
    setSelectedEventType(id);
    onEventScreenChange("OrderEventList");
  };

  const [modalOpen, setModalOpen] = useState(false);

  const checkRequiredFields = () => {
    console.log("TransactionType:", TransactionType);
    console.log("datePaid:", datePaid);
    let missingFields: string = "Required Fields Missing: ";
    if (TransactionType == "") {
      missingFields = missingFields + "TransactionType, ";
    }
    if (datePaid == null || !datePaid.isValid()) {
      console.log("Data missing");
      missingFields = missingFields + "Date Paid, ";
    }
    if (missingFields !== "Required Fields Missing: ") {
      console.log("missingFields1:", missingFields);
      alert(missingFields);
      return true;
    } else {
      console.log("No missing field");
      return false;
    }
  };

  const checkIsAmountPaidEntered = () => {
    if (TransactionType == "Complimentary") {
      return false;
    }
    if (totalAmount === 0 || couponAmount > 0 || AmountPaid > 0) {
      return false;
    } else {
      alert("Please enter Amount");
      return true;
    }
  };

  const checkIsAmountPaid = () => {
    if (TransactionType == "Complimentary") {
      return false;
    }
    if (totalAmount > (AmountPaid + couponAmount)) {
      const userResponse = window.confirm(
        "Amount Paid is less than Billed Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    } else if (totalAmount < (AmountPaid + couponAmount)) {
      const userResponse = window.confirm(
        "Amount Paid is more than Billed Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  const onSubmitPaymentInfo = async () => {
    //e.preventDefault();
    console.log("onSUBMIT:", orderInfo);

    if (isSubmitPaymentInfoLoading) {
      return; // Prevent duplicate submission
    }

    if (checkRequiredFields()) {
      console.log("there are missing filed");
      return;
    }

    if ( checkIsAmountPaidEntered()) {
      return;
    }
    if (checkIsAmountPaid()) {
      return;
    }
    //return;
    setIsSubmitPaymentInfoLoading(true); // Disable the submit button
    console.log("Order log:" , orderInfo);
    //eturn
    //const returnFromOrderInfo: IReturnFromOrderInfo = await onSubmitOrderInfo();
    //console.log("newOrderId:", returnFromOrderInfo.newOrderId);
    //console.log("receiptURL in payment:", returnFromOrderInfo.receiptURL);
    //const apiBody: any = orderInfo;
    //if (returnFromOrderInfo.newOrderId == -1) {
    //   alert("Error while creating order");
    //   return;
    // }
    // const apiBody: any = {
    //   ...orderInfo
    // };
    //const response = await OrderServices.createMembershipPayment(apiBody);
    const response = await OrderServices.createPaymentTran(orderInfo);
    console.log("createPayment response:", response);
    if (response.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      // alert("Payment Posted successfully");
      setReceiptURL(response.data.result[0].InvoiceUrl);
      console.log("Payment response:", response);
      setPIModalOpen(false);
      setViewInvoiceModalOpen(true);
      console.log("setViewInvoiceModalOpen is set to TRUE");
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      // navigate("/member/findmember", { replace: true });
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const handlePICancel = () => {
    setPIModalOpen(false);
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleCreateOrderModelCancel = () => {
    setCreateOrderModalOpen(false);
    console.log("handle Cancel CALLED");
    // navigate("/member/findmember", { replace: true });
  };

  const handleCancelViewInvoiceModal = () => {
    setViewInvoiceModalOpen(false);
    // if (props.isPaymentFlow) {
    //   setPIModalOpen(true);
    // } else {
    // setViewInvoiceModalOpen(false);
    setPIModalOpen(false);
    navigate("/member/findmember", { replace: true });
    // }
  };

  const sectionHandleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    sectionItem: ISection
  ) => {
    console.log("sectionHandleChange", sectionItem);
    console.log("setSelectedItems before", selectedItems);
    console.log("event.target.checked:", event.target.checked);
    console.log("sectionItem:", sectionItem);
    if (event.target.checked) {
      setSelectedItems((selectedItems) => [
        ...selectedItems!,
        Number(event.target.id),
      ]);
      if (props.isPaymentFlow) {
        console.log("TotalSectionAmount2:", totalSectionAmount);
        setTotalSectionAmount(totalSectionAmount + sectionItem.Fee);
        // setDueAmount(totalSectionAmount + sectionItem.Fee);
      }
    } else {
      console.log("Before:", selectedItems);
      setSelectedItems((selectedItems) => {
        const newItems = selectedItems!.filter((item) => item !== Number(event.target.id));
        console.log("After:", newItems);
        return newItems;
      });
      if (props.isPaymentFlow) {
        console.log("TotalSectionAmount3:", totalSectionAmount);
        setTotalSectionAmount(totalSectionAmount - sectionItem.Fee);
        // setDueAmount(dueAmount - sectionItem.Fee);
      }
    }
    console.log("setSelectedItems after", selectedItems);
  };

  const handleChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
    

    const dtNow = new Date();
      // Begin building the FY end date using today's date
      const dtFYEnds = new Date();
      // Set it to July 1 of the current year's date
      dtFYEnds.setFullYear(dtNow.getFullYear(), 6, 1); // Month is 0-indexed, so 6 is July
      // Compare it against July 1 of whatever year we're in
      const dtDiffFS = {
        days: Math.floor((dtFYEnds.getTime() - dtNow.getTime()) / (1000 * 3600 * 24)),
      };
			// Divide that by 365 and multiply by the dues cost of their current code
			const fProRatedDues = Math.round((dtDiffFS.days / 365) * currentMember.MemberCodeFee!!); 

    if(event.target.checked){
      
      setproratedDue(fProRatedDues);
      console.log("fProRatedDues:", fProRatedDues);
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        ProratedDues: fProRatedDues,
      }));
      
    } else {
      setproratedDue(0);
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        ProratedDues: 0,
      }));
      
    }
    //setCheckboxIsSelected(isChecked);
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "PaymentMethod":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PaymentMethod: e.target.value,
        // }));

        dispatch(
          storeUpdateOrder({
            key: "PaymentMethod",
            value: e.target.value,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "TransactionType",
            value: e.target.value,
          })
        );
        break;
      case "CouponAmount":
        dispatch(
          storeUpdateOrder({
            key: "CouponAmount",
            value: e.target.value,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "DueAmount",
            value: (totalAmount-(couponAmount + AmountPaid)),
          })
        );
        break;
      case "DatePaid":
        // const formattedDate = date ? dayjs(date) : null;
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   DatePaid: formattedDate,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: e.target.value,
          })
        );

        break;

      case "CheckNumber":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   CheckNo: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AmountPaid: e.target.value,
        // }));
        setAmountPaid(Number(e.target.value));
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: e.target.value,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "DueAmount",
            value: (totalAmount-(couponAmount + AmountPaid)),
          })
        );
        break;

      case "LateFee":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   LateFee: e.target.value,
        // }));
        setLateFee(Number(e.target.value));
        break;

      case "AuthCode":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AuthCode: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "Comments":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PIComments: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "Comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   NoInvoiceFlag: false,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;

      default:
        console.log("default");
        break;
    }
  };

  const updateMemberCode = (memberCodeId: Number): void => {
    console.log("updateSelectBox:", memberCodeId);
    console.log("memberCodes:", memberCodes);

    memberCodes &&
      memberCodes.filter((item: any) => {
        if (item.Id == memberCodeId) {
          //setMemberCodeId(item.Id);
          setMemberCode(item.MemberCode);
          setMemberCodeDesc(item.Description);
          console.log("setMemberCodeId called:", item.MemberCode);
        }
      });

    if (memberCodes && memberCodeId) {
      const selectedMembercode = memberCodes.find(
        (mc: IMemberCode) => mc.Id === Number(memberCodeId)
      );

      console.log("selected memberCode:", selectedMembercode);
      if (selectedMembercode) {
        setOrderItem((prevOrderItem) => ({
          ...prevOrderItem,
          MemberCodeId: selectedMembercode.Id,
          MemberCode: selectedMembercode.MemberCode,
          MemberCodeDesc: selectedMembercode.Description,
          MemberCodeFee: selectedMembercode.Fee,
          OrderType: "Membership",
        }));
        setMembershipAmount(selectedMembercode.Fee);
        if (props.isPaymentFlow) {
          setDueAmount(dueAmount + selectedMembercode.Fee);
        } else {
          setDueAmount(selectedMembercode.Fee);
        }
        dispatch(
          storeUpdateOrder({
            key: "HasMembershipOrderItem",
            value: true,
          })
        );
      }
      // dispatch(
      //   editMemberPersonal({
      //     key: event.target.name,
      //     value: event.target.value,
      //   })
      // );
    }
  };

  const onSubmitEditMember = (event: React.MouseEvent<EventTarget>) => {
    event.preventDefault();
    console.log("onSubmitEditMember CALLED:", memberCodeId);
    if (memberCodeId === undefined || memberCodeId === null) {
      alert("Please select member code");
      return;
    }
    if(proratedDue!== null){
      const currentYear = new Date().getFullYear(); // Get current year
      dispatch(
        storeUpdateOrder({
          key: "enrollmentStartDate",
          value: dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD"),
        })
      );
      dispatch(
        storeUpdateOrder({
          //storeUpdateOrderItem({
          key: "enrollmentEndDate",
          value: dayjs(new Date(currentYear + 1, 5, 30)).format(
            "YYYY-MM-DD"
          ),
        })
      );
    }
    console.log("totalSectionAmount:", totalSectionAmount);
    console.log("membershipAmount:", membershipAmount);
    var totalSectionAmount_local = totalSectionAmount;
    if(totalSectionAmount === 0 && selectedItems && selectedItems.length >0 && totalNextYearSectionAmount>0) {
      //setTotalSectionAmount(totalNextYearSectionAmount);
      totalSectionAmount_local = totalNextYearSectionAmount;
    }
    
    const totalAmount_local = totalSectionAmount_local + membershipAmount + (proratedDue || 0);
    setTotalAmount(totalAmount_local);
    dispatch(
      storeUpdateOrder({
        key: "TotalAmount",
        value: totalAmount_local,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "DueAmount",
        value: totalAmount_local,
      })
    );
    console.log("orderItem value on submit:", orderItem);
    setCreateOrderModalOpen(true);
  };

  // const onSubmit = async (e: any) => {
  //   e.preventDefault();
  //   console.log("onSUBMIT:", orderInfo);
  //   setModalOpen(false);
  //   const apiBody: any = orderInfo;
  //   const response = await OrderServices.createOrder(apiBody);
  //   // console.log("response", response);
  //   if (response.data.data != null) {
  //     alert("Order Created successfully");
  //     // dispatch(resetOrderParameters());  I am doing this in useEffect
  //     // navigate("/order", { replace: true });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

  //     dispatch(
  //       storeUpdateOrder({
  //         key: "TransactionAmount",
  //         value: 0,
  //       })
  //     );

  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     navigate("/member/findmember", { replace: false });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
  //     //  dispatch(screenChange("Events"));
  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };

  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const handleSendInvoice = async () => {
    if (
      currentMember.PrimaryAddress &&
      currentMember.PrimaryAddress.Email === null &&
      currentMember.PublishedAddress &&
      currentMember.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: props.isPaymentFlow ? receiptURL : invoiceURL,
      FirstName: currentMember.FirstName,
      LastName: currentMember.LastName,
      Esquire: currentMember.Esquire,
      MemberEmail:
        currentMember.PrimaryAddress && currentMember.PrimaryAddress.Email
          ? currentMember.PrimaryAddress.Email
          : currentMember.PublishedAddress &&
            currentMember.PublishedAddress.Email,
    };

    const response = props.isPaymentFlow ? await MemberServices.sendReceiptEmailToMember(body) : await MemberServices.sendInvoiceEmailToMember(body);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      setViewInvoiceModalOpen(false);
      setPIModalOpen(false);
      if (props.isPaymentFlow) {
        navigate("/member/findmember", { replace: true });
      }
    } else {
      console.log("error", response);
    }
    handleCancelViewInvoiceModal();
  };

  const onSubmitOrderInfo = async (e?: any): Promise<IReturnFromOrderInfo> => {
    // e.preventDefault();
    console.log("onSUBMIT:", orderInfo);

    if (isSubmitOrderInfoLoading) {
      const passToSubmitPaymentInfo = {
        receiptURL: null,
        newOrderId: -1,
      };
      return passToSubmitPaymentInfo;
    }
    setIsSubmitOrderInfoLoading(true);

    const apiBody: any = orderInfo;
    try {
      // const response1 = await MemberServices.editMemberSections({
      //   MemberId: currentMember?.Id,
      //   Sections: selectedItems,
      // });
      //if (response1.data.data != null) {
      // if (response1.data.hasErrors) {
      //   setShowAlertModal(true);
      //   setAlertBody(response1.data.errors[0].sqlMessage);
      //   const passToSubmitPaymentInfo = {
      //     receiptURL: null,
      //     newOrderId: -1,
      //   };
      //   return passToSubmitPaymentInfo;
      // }
      // alert("Sections updated  successfully");
      // dispatch(assignCurrentMember(response1.data.data[0]));

      // const response2 = await MemberServices.editMemberCode({
      //   MemberId: currentMember?.Id,
      //   MemberCodeId: memberCodeId,
      // });
      //if (response2.data.data != null) {
      // if (response2.data.hasErrors) {
      //   setShowAlertModal(true);
      //   setAlertBody(response2.data.errors[0].sqlMessage);
      //   const passToSubmitPaymentInfo = {
      //     receiptURL: null,
      //     newOrderId: -1,
      //   };
      //   return passToSubmitPaymentInfo;
      // }
      // alert("MemberCode updated  successfully");
      // dispatch(assignCurrentMember(response2.data.data[0]));

      const response = await OrderServices.createOrderTran(apiBody);
      console.log("createOrder response", response);
      if (response != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          const passToSubmitPaymentInfo = {
            receiptURL: null,
            newOrderId: -1,
          };
          return passToSubmitPaymentInfo;
        }
        //setCreateOrderModalOpen(false);
        console.log("ORDER response", response.data.result[0].OrderId);
        dispatch(
          storeUpdateOrder({
            key: "OrderId",
            value: response.data.result[0].OrderId,
          })
        );
        // const apiBody1: any = {
        //   orderId: response.data.data.insertId,
        //   memberId: orderInfo.MemberId,
        //   paymentStatus: props.isPaymentFlow ? 2 : 1, //invoice created
        //   lateFee: lateFee,
        // };
        // if (
        //   currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
        //   currentMember.MemberCodeId === 21 ||
        //   currentMember.MemberCodeId === 22
        // ) {
        //   alert(
        //     "Order created successfully. No Invoice will be generate for this membercode. "
        //   );
        //   setCreateOrderModalOpen(false);
        //   navigate("/member/findmember", { replace: true });
        //   return response.data.data.insertId;
        // } else
        //{
        // const response1 =
        //   await InvoiceServices.createMembershipOrderInvoiceSync(apiBody1);
        // console.log("INVOICE response", response1);
        let passToSubmitPaymentInfo: IReturnFromOrderInfo = {
          receiptURL: null,
          newOrderId: 0,
        };

        response?.data?.result[0] &&
          console.log("INVOICE URL", response.data.result[0].InvoiceUrl);
        if (
          response.data?.result &&
          Array.isArray(response.data.result) &&
          response.data.result.length > 0
        ) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            const passToSubmitPaymentInfo = {
              receiptURL: null,
              newOrderId: -1,
            };
            return passToSubmitPaymentInfo;
          }

          setinvoiceURL(response.data.result[0].InvoiceUrl);
          console.log("props.isPaymentFlow:", props.isPaymentFlow);

          setCreateOrderModalOpen(false);
          console.log("INVOICE response1", response.data.result[0].InvoiceUrl);
          // cancel old invoice and orders for current FY.
          console.log(
            "CO: currentYearActiveOrderId:",
            props.currentYearActiveOrderId
          );

          // for (const orderId of props.currentYearActiveOrderId) {
          //   console.log("Before calling cancelOrder");
          //   try {
          //     const responseCO = await OrderServices.cancelOrder(orderId);
          //     if (responseCO.data != null) {
          //       if (responseCO.data.hasErrors) {
          //         setShowAlertModal(true);
          //         setAlertBody(responseCO.data.errors[0].sqlMessage);
          //         const passToSubmitPaymentInfo = {
          //           receiptURL: null,
          //           newOrderId: -1,
          //         };
          //         return passToSubmitPaymentInfo;
          //       }
          //       console.log("cancelORder SUCCESS respnse:", responseCO.data);
          //     } else {
          //       console.log("Error: Response data is null");
          //     }
          //   } catch (error) {
          //     console.log("Catch Error", error);
          //   }
          // }

          //   if (props.isPaymentFlow) {
          //     const response2 =
          //       await InvoiceServices.createMembershipPaymentReceiptSync(
          //         apiBody1
          //       );
          //     setReceiptURL(response2.data.result);
          //     console.log("INVOICE response", response2.data.result);
          //     console.log("new OrderID", response.data.data.insertId);
          //     passToSubmitPaymentInfo = {
          //       receiptURL: response2.data.result,
          //       newOrderId: response.data.data.insertId,
          //     };
          //   }
          //   if (
          //     response1?.data?.data &&
          //     Array.isArray(response1.data.data) &&
          //     response1.data.data.length > 0
          //   )
          //     if (response1.data.hasErrors) {
          //       setShowAlertModal(true);
          //       setAlertBody(response1.data.errors[0].sqlMessage);
          //       const passToSubmitPaymentInfo = {
          //         receiptURL: null,
          //         newOrderId: -1,
          //       };
          //       return passToSubmitPaymentInfo;
          //     }
          if (!props.isPaymentFlow) {
            console.log("Show invoice");
            setViewInvoiceModalOpen(true);
          }
          // else {
          //   navigate("/member/findmember", { replace: true });
          // }
        }
        return passToSubmitPaymentInfo; //response.data.data.insertId;
        //}
      } else {
        // alert(response.data.errors);
        console.log("error");
        const passToSubmitPaymentInfo = {
          receiptURL: null,
          newOrderId: -1,
        };
        return passToSubmitPaymentInfo;
      }
      //} // member code end else part
      //   const passToSubmitPaymentInfo = {
      //     receiptURL: null,
      //     newOrderId: -1,
      //   };
      //   return passToSubmitPaymentInfo;
      // } else {
      //   console.log("Sections update failed");
      //   const passToSubmitPaymentInfo = {
      //     receiptURL: null,
      //     newOrderId: -1,
      //   };
      //   return passToSubmitPaymentInfo;
      // }
    } catch (error) {
      console.error("ORDER: Error creating order:", error);
      const passToSubmitPaymentInfo = {
        receiptURL: null,
        newOrderId: -1,
      };
      return passToSubmitPaymentInfo;
    }
  };

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };

  // const cancelOrder = () => {
  //   navigate(routeConfig.MEMBERS_URL, { replace: false });
  // };

  return (
    <div className="dashboard-wrapper" style={{ paddingBottom: "100px" }}>
      <div className="horizontal-wrapper-leftaligned">
        <div className="horizontal-wrapper-leftaligned">
          <h3 className="section-heading" style={{ marginRight: "5px" }}>
            Member Code{" "}
          </h3>
        </div>
        <form
          className="form-wrapper"
          //onSubmit={createOrderHandleSubmit(onSubmitEditMember)}
          noValidate
          name="memberForm"
          id="memberForm"
        >
          <div className="horizontal-wrapper-leftaligned">
            <div
              className="input-field-div-wrapper"
              style={{ marginBottom: "4px" }}
            >
              <select
                className="dropdown-control-large-insidetextfield"
                id="MemberCodeId"
                // {...createOrderRegister("MemberCodeId", {
                //   required: "Member Code is a required field",
                // })}
                onChange={(e) => {
                  const selectedValue = Number(e.target.value);
                  updateMemberCode(selectedValue);
                  // setValueMF("MemberCodeId", selectedValue, {
                  //   shouldValidate: true,
                  //   shouldDirty: true,
                  // }); // Update the form state and mark it as dirty
                }}
                disabled={true}
                
                value={
                  typeof memberCodeId !== "undefined" && memberCodeId != null
                    ? memberCodeId
                    : ""
                }
              >
                <option value={""}> Select Member Code ( * )</option>
                {memberCodes?.map((MemberCode: any) =>
                  MemberCode.Status ? (
                    <option key={MemberCode.Id} value={MemberCode.Id}>
                      {MemberCode.MemberCode} {" - "} {MemberCode.Description}
                    </option>
                  ) : null
                )}
                ;
              </select>
              {/* <p className="form-error  form-error-position">
              {errors.MemberCodeId?.message}
            </p> */}
            </div>
            
              <div
                className="vertical-wrapper-alignleft"
                style={{ marginLeft: "16px" }}
              >
                <div style={{ marginBottom: "4px" }}>
                  <span
                    style={{
                      color: "#366287",
                      marginLeft: "4px",
                    }}
                  >
                    Previous Code:{" "}
                  </span>
                  {lastMemberCode && (
                    <span style={{ fontWeight: "500" }}>{lastMemberCode}</span>
                  )}
                  <span style={{ fontWeight: "500" }}> {" - "}</span>
                  {lastMemberCodeDesc && (
                    <span style={{ fontWeight: "500" }}>
                      {lastMemberCodeDesc}
                    </span>
                  )}
                </div>
                <div>
                  <span style={{ color: "#366287", fontWeight: "500" }}>
                    Years Since Admitted:{" "}
                  </span>
                  <span style={{ fontWeight: "500" }}>
                    {currentMember.YearsAdmitted}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <input
                    id="prorateCheckbox"
                    className="checkbox"
                    type="checkbox"
                    checked={proratedDue  !== null}
                    disabled={currentMonth <=2 || currentMonth >=7 || props.isPaymentFlow}
                    onChange={(event) => {
                      handleChecked(event);
                    }}
                  />
                  <span style={{ fontWeight: "500" }}>
                    Include Current Fiscal Year on Prorated Fees
                  </span>
                </div>
              </div>
            
          </div>

          <div className="horizontal-wrapper-leftaligned">
            <h3 className="section-heading">Sections</h3>
          </div>
          <div className="sections-section">
            {isMembersActiveOrdersLoaded &&
              Sections &&
              Sections.map((section: ISection) =>
                section.Status ? (
                  <MDEditSectionMultipleOptionItems
                    section={section}
                    isAdvanceOrder = {true}
                    isAddSectionFlow={isAddSectionFlow}
                    // membersActiveOrders={
                    //   MembersActiveOrders.memberShipOrderDetails
                    // }
                    onChangeFunction={sectionHandleChange}
                  />
                ) : null
              )}
          </div>

          <div
            className="button-wrapper"
            style={{ width: "100%", marginTop: "2rem", marginBottom: "100px" }}
          >
            <div className="submit-button-div">
              <Button type="submit" onClick={onSubmitEditMember}>
                Submit
              </Button>
            </div>
          </div>
        </form>
      </div>
      <ReactModal
        isOpen={createOrderModalOpen}
        onRequestClose={() => {
          handleCreateOrderModelCancel();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Create Order</h1>
          {/* <PageLink onClick={handleCancel}>Cancel</PageLink> */}
          <div className="secondary-button">
            <Button type="submit" onClick={handleCreateOrderModelCancel}>
              Close
            </Button>
            {/* </div> */}
          </div>
        </div>
        <form
          className="form-wrapper"
          onSubmit={(e) => {
            e.preventDefault();
            if (!props.isPaymentFlow) {
              handleSubmitOrder(onSubmitOrderInfo)(e);
            } else {
              setPIModalOpen(true); // Open the payment modal.
              setCreateOrderModalOpen(false); // Close the order creation modal.
            }
          }}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <Label>Order Date</Label>
            <input
              className="input-field-div input-disabled"
              id="OrderDate"
              name="OrderDate"
              value={dayjs().format("YYYY-MM-DD")}
              disabled={true}
            />
          </div>
          <div
            className="horizontal-wrapper-spacebetween-center"
            style={{ width: "48%" }}
          >
            {orderItem.MemberCode && (
              <>
                <label className="orderitem-header">MemberShip Code</label>
                <div className="horizontal-wrapper-rightaligned">
                  <label className="orderitem-label">
                    {orderItem.MemberCode}
                    {orderItem.MemberCode ? "-" : null}
                    {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                  </label>
                  <label
                    style={{
                      width: "10%",
                      paddingLeft: "0.5rem",
                    }}
                  >
                    :
                  </label>
                  <span className="orderitem-value">
                    {Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(orderItem.MemberCodeFee as number)}
                  </span>
                </div>
                {orderItem.ProratedDues ? 
                  <>
                  <div className="horizontal-wrapper-rightaligned">
                    <label className="orderitem-label">
                      Prorated Dues
                    </label>
                    <label
                    style={{
                      width: "10%",
                      paddingLeft: "0.5rem",
                    }}
                  >
                    :
                  </label>
                  <span className="orderitem-value">
                    {Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(orderItem.ProratedDues as number)}
                  </span>
                </div>
                </> : <></>}
              </>
            )}
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                <label className="orderitem-header">Sections</label>
                {props.isPaymentFlow ? (
                  <></>
                ) : (
                  <label
                    style={{
                      marginTop: "0.4rem",
                    }}
                  >
                    (suggested)
                  </label>
                )}
              </div>
              {Sections &&
                Sections.map((sectionItems: ISection) =>
                  selectedItems && selectedItems.includes(sectionItems.Id) ? (
                    <>
                      <div className="horizontal-wrapper-leftaligned">
                        <label className="orderitem-label">
                          {sectionItems.SectionName}
                        </label>
                        <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          :
                        </label>
                        <span className="orderitem-value">
                          {/* {props.isPaymentFlow ? <></> : <span>(</span>}
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(sectionItems.Fee as number)}
                          {props.isPaymentFlow ? <></> : <span>)</span>} */}
                          {props.isPaymentFlow ? (
                            <>
                              {Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                              }).format(sectionItems.Fee as number)}
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )}
              <div
                className="order-totalorder"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              >
                <span className="orderitem-label"> TOTAL AMOUNT </span>
                <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(totalAmount as number)}
                </span>
              </div>
            </>
          </div>

          {(orderItem.MemberCodeId && orderItem.MemberCodeId === 21) ||
          (orderItem.MemberCodeId && orderItem.MemberCodeId === 22) ? (
            <div className="order-checkboxgroup">
              <input
                id="NoInvoiceFlag"
                name="NoInvoiceFlag"
                className="checkbox"
                type="checkbox"
                // onChange={(e) => updatePaymentInfo(e)}
                // disabled={true}
                readOnly={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
                checked={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
              />
              <div>
                <span>
                  No Invoice
                  {currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22 ? (
                    <span style={{ color: "red" }}>
                      {" "}
                      ({currentMember.Description})
                    </span>
                  ) : null}
                </span>
              </div>
            </div>
          ) : null}
          <div
            className="horizontal-wrapper-spaceevenly"
            style={{ marginTop: "2rem", marginBottom: "0.5rem" }}
          >
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                {isSubmitOrderInfoLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>
      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => {
          handleCancelViewInvoiceModal();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View Invoice / Receipt</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button type="submit" onClick={handleCancelViewInvoiceModal}>
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email {props.isPaymentFlow ? "Receipt" : "Invoice"}
              </Button>
              {/* </div> */}
            </div>
          </div>
          <div className="pdf-container">
            {props.isPaymentFlow ? (
              <iframe src={receiptURL} allow="autoplay" loading="lazy"></iframe>
            ) : (
              <iframe src={invoiceURL} allow="autoplay" loading="lazy"></iframe>
            )}
          </div>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={PIModalOpen}
        onRequestClose={() => {
          setPIModalOpen(false);
        }}
        className="editinfo-modal-medium"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Update Pay Information</h1>
          <PageLink onClick={handlePICancel}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitPaymentInfo)}
          noValidate
        >
          {/* <div className="input-field-div-wrapper">
                  <input
                    className="input-field-div-small"
                    id="PaymentMethod"
                    name="PaymentMethod"
                    placeholder=""
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                    disabled={false}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="PaymentMethod">
                    Payment Method
                  </label>
                </div> */}

          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="PaymentMethod"
              onChange={(e) => {
                updatePaymentInfo(e);
                setTransactionType(e.target.value);
              }}
            >
              <option value={""}> Select Payment Type </option>
              <option value="American Express">American Express</option>
              <option value="Authorize.net">Authorize.net</option>
              <option value="Check">Check</option>
              <option value="Discover">Discover</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Website">Website</option>
              <option value="Complimentary">Complimentary</option>
            </select>
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={controlPI}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      value={value ? dayjs(value).toDate() : null}
                      onChange={(date: Date | null) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null;
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                        date && setDatePaid(dayjs(date));
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="CheckNumber"
              name="CheckNumber"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CheckNumber">
              Check Number
            </label>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AmountPaid"
              name="AmountPaid"
              pattern="0-9"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              value={orderInfo.AmountPaid}
              // disabled={true}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AmountPaid">
              Amount Paid
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="LateFee"
              name="LateFee"
              placeholder=""
              pattern="[0-9]*"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="LateFee">
              Late Fee
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AuthCode"
              name="AuthCode"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AuthCode">
              Auth Code
            </label>
          </div>

          <div
            className="input-field-div-wrapper"
            style={{ marginTop: "2rem" }}
          >
            <input
              className="input-field-div-small"
              id="CouponAmount"
              name="CouponAmount"
              pattern="[0-9]*"
              placeholder=""
              value={couponAmount}
              onChange={(e) => {
                const amount = parseInt(e.target.value) || 0;
                setCouponAmount(amount);
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CouponAmount">
              Discount Amount
            </label>
          </div>

          <div
            className="input-field-div-wrapper"
            style={{ marginTop: "2rem" }}
          >
            <input
              className="input-field-div-small"
              id="TotalAmount"
              name="TotalAmount"
              pattern="[0-9]*"
              placeholder=""
              value={totalAmount}
              disabled={true}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="TotalAmount">
              Total Amount
            </label>
          </div>

          <div className="textarea-wrapper" style={{ width: "28%" }}>
            <TextField
              className="textarea"
              id="Comments"
              name="Comments"
              placeholder="Comments"
              multiline
              rows={3}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
            {/* <label className="form-label" htmlFor="PIcomments">
                    Comments
                  </label> */}
          </div>

          {/* <div className="order-checkboxgroup">
                  <input
                    id="NoInvoiceFlag"
                    name="NoInvoiceFlag"
                    className="checkbox"
                    type="checkbox"
                    onChange={(e) => updatePaymentInfo(e)}
                  />
                  <div>
                    <span> No Invoice</span>
                  </div>
                </div> */}

          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                {isSubmitPaymentInfoLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CreateAdvanceOrder;
